import angular from 'angular';
import {
  alerts
} from 'app/components/global';
import {
  loaderService,
  ssDialogService,
  bcpDataService
} from 'app/services';
import controller from './edit-it-core-procedures-dialog.controller';
import template from './edit-it-core-procedures-dialog.html';

import itCoreProceduresTextMessagesTpl from './messages/it-core-procedures.text.messages.html';

class dialogService {
  getOptions($event, {
    // eslint-disable-next-line no-shadow
    assessmentItCoreProcedures
  }) {
    return {
      controller,
      controllerAs: 'editITCoreProceduresDialogVM',
      locals: {
        assessmentItCoreProcedures,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.bcp.editITCoreProceduresDialog', [
  loaderService,
  ssDialogService,
  bcpDataService,
  alerts,
])
  .service('editITCoreProceduresDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('it-core-procedures.text.messages.html', itCoreProceduresTextMessagesTpl);
  })
  .name;
